import { useMemo } from 'react';
import { getResolverUrl } from '@atlaskit/linking-common';
export var useResolverUrl = function useResolverUrl(cardClient) {
  return useMemo(function () {
    return getResolverUrl(cardClient === null || cardClient === void 0 ? void 0 : cardClient.envKey, cardClient === null || cardClient === void 0 ? void 0 : cardClient.baseUrlOverride);
  }, [cardClient === null || cardClient === void 0 ? void 0 : cardClient.baseUrlOverride, cardClient === null || cardClient === void 0 ? void 0 : cardClient.envKey]);
};